var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommend-list"},[_c('van-search',{attrs:{"placeholder":"请输入姓名/职位/订单ID等","shape":"round","left-icon":""},on:{"search":_vm.onSearch},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }